import templateStr from 'text!./policy-diff-section.html';
import './policy-diff-section.scss';

export default [function () {
    return {
        restrict: 'E',
        template: templateStr,
        controller: controller,
        scope: {
            policyDiffSection: '='
        }
    };
}];

const controller = ['$scope', ($scope) => {
    $scope.nesting = 1;
    $scope.showChildren = true;

    $scope.toggleChildren = () => {
        $scope.showChildren = !$scope.showChildren;
    };
}];